module.exports = (__webpack_require__(37893))(3336);